// OK 17/10/2024

import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { signin as login, signout as logout } from "../../apis/auth";
import { AuthContext } from "../../context";
import { Persons } from "../../interfaces";

function AuthProvider({ children }: any) {
  let initialUser = useLoaderData() as Persons | null;
  if (initialUser?.idPers == null) {
    initialUser = null;
  }
  const [user, setUser] = useState<Persons | null>(initialUser);
  async function signin(credentials: any) {
    const newUser = await login(credentials);
    setUser(newUser);
  }
  async function signout() {
    await logout();
    setUser(null);
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        signin,
        signout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
